const initialPatients = [
  {
    id: 1,
    patientId: 'a8G5zK3XQ'.toUpperCase()
,
    firstName: 'Alice',
    middleName: 'Q.',
    lastName: 'Johnson',
    dob: '1984-05-23',
    genderWithInsurance: 'Female',
    phoneNumber: '555-1234',
    email: 'alice.j@example.com',
    address: '1234 Main St',
    city: 'Anytown',
    state: 'CA',
    zip: '90210',
    diagnosis: 'Rotator cuff surgery',
    numberOfRequestedVisits: 16,
    treatmentNotes: 'Rehab shoulder',
    referringPhysician: 'Clara Huxley, MD'
  },
  {
    id: 2,
    patientId: 'B3n9YxV7t'.toUpperCase(),
    firstName: 'Bob',
    middleName: 'L.',
    lastName: 'Smith',
    dob: '1978-04-17',
    genderWithInsurance: 'Male',
    phoneNumber: '555-5678',
    email: 'bob.s@example.com',
    address: '4321 First St',
    city: 'Anytown',
    state: 'CA',
    zip: '90210',
    diagnosis: 'Back Pain',
    numberOfRequestedVisits: 3,
    treatmentNotes: 'Initial assessment required',
    referringPhysician: 'Dr. Marcus Wellborne'
  },
  {
    id: 3,
    patientId: 'X2Lm4aTqR'.toUpperCase(),
    firstName: 'Charlie',
    middleName: 'M.',
    lastName: 'Brown',
    dob: '1990-08-30',
    genderWithInsurance: 'Male',
    phoneNumber: '555-8765',
    email: 'charlie.b@example.com',
    address: '987 Elm St',
    city: 'Othertown',
    state: 'TX',
    zip: '30022',
    diagnosis: 'Knee Pain',
    numberOfRequestedVisits: 8,
    treatmentNotes: 'Eval required',
    referringPhysician: 'Evelyn Storrow, D.O.'
  },
  {
    id: 4,
    patientId: 'zQ5Mn6WbP'.toUpperCase(),
    firstName: 'Diana',
    middleName: 'F.',
    lastName: 'Prince',
    dob: '1982-07-09',
    genderWithInsurance: 'Female',
    phoneNumber: '555-4321',
    email: 'diana.p@example.com',
    address: '321 Fourth St',
    city: 'Sometown',
    state: 'NY',
    zip: '10001',
    diagnosis: 'Pulled hamstring',
    numberOfRequestedVisits: 2,
    treatmentNotes: 'Include massage',
    referringPhysician: 'Dr. Leo Carrington'
  },
  {
    id: 5,
    patientId: 'Jk83nPfz7'.toUpperCase(),
    firstName: 'Eva',
    middleName: 'G.',
    lastName: 'Green',
    dob: '1975-03-20',
    genderWithInsurance: 'Female',
    phoneNumber: '555-9876',
    email: 'eva.g@example.com',
    address: '654 Pine St',
    city: 'Anothertown',
    state: 'FL',
    zip: '33101',
    diagnosis: 'Sprained ankle',
    numberOfRequestedVisits: 1,
    treatmentNotes: 'Apply ice, rest',
    referringPhysician: 'Nora Fieldstone, M.D.'
  },
  {
    id: 6,
    patientId: 'TzV98weK1'.toUpperCase(),
    firstName: 'Frank',
    middleName: 'H.',
    lastName: 'Ocean',
    dob: '1987-10-28',
    genderWithInsurance: 'Male',
    phoneNumber: '555-1122',
    email: 'frank.o@example.com',
    address: '5678 Maple St',
    city: 'Heretown',
    state: 'WA',
    zip: '98101',
    diagnosis: 'Repaired achilles tendon',
    numberOfRequestedVisits: 24,
    treatmentNotes: 'See 2x per week for 12 weeks',
    referringPhysician: 'Isaiah Morrow'
  },
  {
    id: 7,
    patientId: 'uW6eLr29Q'.toUpperCase(),
    firstName: 'Grace',
    middleName: 'I.',
    lastName: 'Hopper',
    dob: '1952-12-09',
    genderWithInsurance: 'Female',
    phoneNumber: '555-2233',
    email: 'grace.h@example.com',
    address: '321 Cedar St',
    city: 'Wheretown',
    state: 'CO',
    zip: '80201',
    diagnosis: 'Knee replacement',
    numberOfRequestedVisits: 24,
    treatmentNotes: '3x per week for 8 weeks',
    referringPhysician: 'Julia Bancroft, DO'
  },
  {
    id: 8,
    patientId: 'Np7LxFzW2'.toUpperCase(),
    firstName: 'Alex',
    middleName: 'P.',
    lastName: 'Person',
    dob: '1981-06-15',
    genderWithInsurance: 'Nonbinary',
    phoneNumber: '555-3344',
    email: 'henry.l@example.com',
    address: '213 Oak St',
    city: 'Thistown',
    state: 'IL',
    zip: '60601',
    diagnosis: 'Muscle weakness in legs',
    treatmentNotes: 'Work on strenghtening legs',
    referringPhysician: 'Theodore Raines, MD'
  }
];

export default initialPatients;